/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import React from "react";

interface CircleContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor?: string;
  height: string;
  width: string;
  minHeight?: string;
  minWidth?: string;
  children?: React.ReactNode;
  additionalStyling?: SerializedStyles;
}

export const CircleContainer = ({
  backgroundColor,
  className,
  width,
  height,
  minHeight,
  minWidth,
  children,
  additionalStyling,
  ...rest
}: CircleContainerProps) => {
  const wrapperStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${height};
    width: ${width};
    min-width: ${minWidth || width};
    min-height: ${minHeight || height};
    border-radius: 9999px;
    background-color: ${backgroundColor};
    ${additionalStyling}
  `;

  return (
    <div css={wrapperStyle} {...rest}>
      {children}
    </div>
  );
};
